export default __webpack_public_path__ + "static/media/SawbillLogo.20301c28.png";